import { Collapse, IconButton, TableCell, TableRow } from '@mui/material'
import React, { useState } from 'react'
import { getUserName } from '../../../helpers/user/UserHelper'
import { departmentText, getDepartmentTypeFromDepartmentObj } from '../../../helpers/department/DepartmentHelper'
import { getDateAndTimeText } from '../../../helpers/date/dateHelper'
import { Link } from 'react-router-dom'
import Status from '../../UI/status/Status'
import SupplyOrderItemsAgreeCount from '../supplyOrder/view/items/fields/SupplyOrderItemsAgreeCount'
import SupplyOrderItemReceivedShort from './fields/SupplyOrderItemReceivedShort'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp'
import InnerTable from '../../UI/table/inner/InnerTable'
import SupplyOrderItemsTableShort from '../supplyOrder/view/itemsShort/SupplyOrderItemsTableShort'
import MyTableMoreIco from '../../UI/table/MyTableMoreIco'

const SupplyOrderItem = ({ supplyOrder }) => {

	const [open, setOpen] = useState(false)

  return (
	<>
		<TableRow>
			<MyTableMoreIco 
				open={open}
				setOpen={setOpen}
			/>
			<TableCell align='center'>
				<Link to={`/supply/orders/${supplyOrder.id}`}>
					{supplyOrder.id}
				</Link>
				{/* {supplyOrder.id} */}
			</TableCell>
			<TableCell align='center'>
				{
					<Status status={supplyOrder.status} />
					// supplyOrder.status
				}
			</TableCell>
			<TableCell align='center'>
				{
					getUserName({
						user: supplyOrder.client
					})
				}
			</TableCell>
			<TableCell align='center'>
				{
					supplyOrder.departmentType ? 
						supplyOrder.departmentType.name + ' - '
					: ''
				}
				{
					supplyOrder.department ? 
						supplyOrder.department.name
					: ''
				}
			</TableCell>
			<TableCell align='center'>
				{
					getUserName({
						user: supplyOrder.user
					})
				}
			</TableCell>
			<TableCell align='center'>
				<SupplyOrderItemsAgreeCount
					supplyOrderItems={supplyOrder.items} 
				/>
			</TableCell>
			<TableCell align='center'>
				<SupplyOrderItemReceivedShort 
					isReceivedAll={supplyOrder.isReceivedAll}
				/>
			</TableCell>
			<TableCell align='center'>
				{
					getDateAndTimeText(supplyOrder.createdAt)
				}
			</TableCell>
			{/* <TableCell align="center" className='myTable__actions'>
				
			</TableCell> */}
		</TableRow>

		<InnerTable
			open={open}
		>
			<SupplyOrderItemsTableShort 
				supplyOrderItems={supplyOrder.items}
			/>
		</InnerTable>
	</>
  )
}

export default SupplyOrderItem